
import Header from '../Header'
import Menu from '../Menu'
import College from '../components/college/CollegeManage'
function CollegeManage() {

  return (
    <div>
      <Header/>
      <Menu/>
        <div className="content-wrapper">
          {/* Content Header (Page header) */}
          <College/>

          {/* /.content */}
        </div>
      </div>
  )
}

export default CollegeManage
